export default "__VITE_ASSET__292df34c__"